import Text from '@components/Text';
import colors from '@constants/colors';
import { ChangeEventHandler, useRef } from 'react';

import ImageIcon from './ImageIcon';
import styles from './styles.module.scss';

interface Props {
    onChange?: ChangeEventHandler<HTMLInputElement>;
}

function FileUploader({ onChange }:Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  return (
        <div className={styles.container}
             onClick={() => inputRef.current?.click()} >
            <Text color={colors.gray5}>
                10mb 이내의 png, gif, jpeg만 가능합니다.
            </Text>
            <ImageIcon/>
            <input type='file' hidden
                   onChange={onChange}
                   ref={inputRef} />
        </div>
  );
}

export default FileUploader;
